/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
import React from 'react'
import {ListHeader} from './ListHeader'
import {ListContent} from './ListContent'
import styles from '../style/list.css'

export interface RowItem {
  id: string
}

export interface RowColumnComponentProps<Item> {
  item: Item
}

export interface ColumnSpec<Item extends RowItem> {
  id: string
  width?: number
  HeaderComponent: React.ComponentClass<any> | React.FunctionComponent<any> | null
  Component:
    | React.ComponentClass<RowColumnComponentProps<Item>>
    | React.FunctionComponent<RowColumnComponentProps<Item>>
  [key: string]: unknown
}
export interface ListProps<Item extends RowItem> {
  columnSpecs: ColumnSpec<Item>[]
  items: Item[]
  onRowClick?: (item: Item) => void
  onLoadMore: (page: number) => void
  hasMoreData: boolean
  expandedState: Set<string>
  ExpandedRowComponent?: React.ComponentType<{item: RowItem}>
}

export function List<Item extends RowItem>(props: ListProps<Item>) {
  return (
    <div className={styles['list']}>
      <ListHeader {...props} />
      <ListContent {...props} />
    </div>
  )
}
